import Vue from "vue";
import axios from "axios";
import router from "@/router";
import errorHandle from "./errorHandle";

var axios_base = axios.create({ baseURL: "/api/wz_api_php/api/" });
Vue.prototype.axios_base = axios_base;
window.axios_base = axios_base;

axios.jsonp = url => {
  if (!url) {
    console.error("Axios.JSONP 至少需要一个url参数!");
    return;
  }
  return new Promise((resolve, reject) => {
    window.jsonCallBack = result => {
      console.log(result);
      resolve(result);
    };
    var JSONP = document.createElement("script");
    JSONP.type = "text/javascript";
    JSONP.src = `${url}&callback=jsonCallBack`;
    document.getElementsByTagName("head")[0].appendChild(JSONP);
    setTimeout(() => {
      document.getElementsByTagName("head")[0].removeChild(JSONP);
    }, 500);
  });
};

//请求拦截器
axios_base.interceptors.request.use(
  config => {
    config.timeout = 5 * 60 * 1000; //请求响应时间
    var token = localStorage.getItem("yc_token");
    if (token) {
      // 判断是否存在token，如果存在的话，则每个http header都加上token
      config.headers.token = token;
    }
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

// 响应拦截器
axios_base.interceptors.response.use(
  // 请求成功
  res => (res.status === 200 ? Promise.resolve(res) : Promise.reject(res)),
  // 请求失败
  error => {
    const { response } = error;
    if (response) {
      // 请求已发出,但是不在2xx的范围
      errorHandle(response.status, response.data.message);
      return Promise.reject(response);
    }
  }
);

const reqAuth = axios.create({
  baseURL: "http://uuc.it.czczh.cn/gw/novauc/"
});
//请求拦截器
reqAuth.interceptors.request.use(
  config => {
    config.timeout = 5 * 60 * 1000; //请求响应时间
    // if (config.url[0] === "/") {
    // config.baseURL = "";
    // }
    var token = localStorage.getItem("yc_token");
    if (token) {
      // 判断是否存在token，如果存在的话，则每个http header都加上token
      if (config.auth !== false) {
        config.headers.Authorization = `Bearer ${token}`;
      }
    } else {
      router.replace({ name: "login" });
    }
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

// 响应拦截器
reqAuth.interceptors.response.use(
  // 请求成功
  res => (res.status === 200 ? Promise.resolve(res) : Promise.reject(res)),
  // 请求失败
  error => {
    const { response } = error;
    if (response) {
      // 请求已发出,但是不在2xx的范围
      errorHandle(response.status, response.data.message);
      return Promise.reject(response);
    }
  }
);

export { reqAuth };



// WEBPACK FOOTER //
// ./src/api/api_request.js